export type PaginatedResponse<T> = {
  total: number
  data: T[]
  limit: number
  skip: number
}

export interface ApiConfig {
  baseUrl: string
  headers?: Record<string, string>
}

export type FeathersJSError = {
  className:
    | 'conflict'
    | 'badrequest'
    | 'unauthorized'
    | 'forbidden'
    | 'not-found'
    | 'method-not-allowed'
    | 'not-acceptable'
    | 'timeout'
    | 'conflict'
    | 'length-required'
    | 'unprocessable'
    | 'general'

  code: number
  message: string
  name: string
}

export class ApiError extends Error {
  code: number
  name: string
  className:
    | 'conflict'
    | 'badrequest'
    | 'unauthorized'
    | 'forbidden'
    | 'not-found'
    | 'method-not-allowed'
    | 'not-acceptable'
    | 'timeout'
    | 'conflict'
    | 'length-required'
    | 'unprocessable'
    | 'general'

  constructor(error: FeathersJSError) {
    super(error.message)
    this.code = error.code
    this.name = error.name
    this.className = error.className
  }
}
